import { render } from "./Carousel.vue?vue&type=template&id=35e876a9&scoped=true"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"

import "./Carousel.vue?vue&type=style&index=0&id=35e876a9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-35e876a9"

export default script